module.exports = __webpack_public_path__ + "static/img/vote_A.6812ed9.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/vote/vote_A.png
// module id = /YRC
// module chunks = 1